import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_GET_LISTING_LIST } from 'api/actionTypes';

import {
  LISTINGS_DATA_MANAGER_VIEW_ID_APARTMENT_LISTINGS,
  makeListingsStateManagerViewPath,
  actionInitializeListingStateView,
  actionListingsStateViewLoadNextPage,
} from 'client/helpers/listingsStateManager';

export function makeListingStateManagerViewId({ apartmentBuildingId }) {
  typeCheck('apartmentBuildingId::Array|Number', apartmentBuildingId);
  return [LISTINGS_DATA_MANAGER_VIEW_ID_APARTMENT_LISTINGS, apartmentBuildingId].join(':');
}

export default async function getApartmentListings({ state, apiClient }, { apartmentBuildingId }) {
  const viewId = makeListingStateManagerViewId({ apartmentBuildingId });
  const listingsViewPath = makeListingsStateManagerViewPath(viewId);

  if (!state.exists(listingsViewPath)) {
    actionInitializeListingStateView(
      { state },
      {
        viewId,
        count: 6,
        action: SR_API_ACTION_GET_LISTING_LIST,
        filters: {
          apartmentBuildingId: apartmentBuildingId,
        },
      },
    );
  }

  if (!state.get(listingsViewPath.concat('isFullyLoaded'))) {
    await actionListingsStateViewLoadNextPage({ state, apiClient }, { viewId });
  }
}
